import { IVenueGroup } from "../components/groupsManagement/state/groupsManagement.reducer";
import { IProfileForms } from "../components/profile/SettingsProfileComponent";

import { MultiVendorOrdering } from "../formSchemas/customLabel.form";

import IVenue from "../interfaces/IVenue";
import { ICallAPIFunction } from "../yoello-lib/modules/API2/types";
import { DeleteItems } from "../yoello-lib/modules/dynamicForms/CustomFormComponents/DeleteItems";
import { ILanguage } from "../yoello-lib/modules/redux/actions/localization";
import { groupForm } from "./group.form";


export const GeneralForm = (t: any ,
   callAPI:ICallAPIFunction<IVenueGroup | IVenueGroup[]>,
   venues:Partial<IVenue>[],
   languages:ILanguage[],
   formData:IVenueGroup, 
   onDelete:()=>void, 
   isLoading:boolean, 
   setInputValue:(value:string)=>void): IProfileForms[] => {
  return [
    {
      formRows: groupForm(t,venues,languages,isLoading,setInputValue,true),
      title: "groups.form.groupDetails",
      formKey: "updateGroups",
      formButtonText:"groups.buttons.updateGroupDetails"
    },
    {
      formRows: MultiVendorOrdering(t),
      title: "groups.form.multiVendorOrdering",
      formKey: "multiVendorOrdering",
      formButtonText:"groups.buttons.updateMultiVendorOrdering",
      disable:!formData.group_settings.has_multi_ordering_permission 
    },
    {
      formRows: [
        {
          label: "delete.label",
          Component: DeleteItems,
          formProps: {
              item: formData,
              callAPI: callAPI, 
              ParentComponent:null,
              keyLabel: 'group',
              onDelete:onDelete
          },
          keyName: "delete",
      }
      ],
      title: "groups.form.deleteGroup",
      formKey: "deleteGroup",
    }
  ];
};

